/* Jaiman Toys — Play Zone (just for fun, no login, no rewards). 8 canvas mini-games. */
(function () {
  'use strict';
  var W = 360, H = 540;
  var PALETTE = ['#f5b21e', '#e76ca9', '#8c4c9e', '#4ea585', '#b8d87a', '#f15a5d', '#3d5dab', '#68c8c7', '#0ac0dd'];

  var store = {
    get: function (k) { try { return parseInt(localStorage.getItem('jtpz_' + k), 10) || 0; } catch (e) { return 0; } },
    set: function (k, v) { try { localStorage.setItem('jtpz_' + k, String(v)); } catch (e) {} }
  };
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function rrect(c, x, y, w, h, r) {
    c.beginPath();
    if (c.roundRect) { c.roundRect(x, y, w, h, r); } else { c.rect(x, y, w, h); }
  }
  function emoji(c, ch, x, y, size) {
    c.font = size + 'px "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif';
    c.textAlign = 'center'; c.textBaseline = 'middle';
    c.fillText(ch, x, y);
  }
  function text(c, s, x, y, size, color, weight) {
    c.font = (weight || 700) + ' ' + size + 'px Comfortaa, "Nunito", sans-serif';
    c.fillStyle = color || '#2b1a33'; c.textAlign = 'center'; c.textBaseline = 'middle';
    c.fillText(s, x, y);
  }
  function sky(c, top, bottom) {
    var g = c.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, top); g.addColorStop(1, bottom);
    c.fillStyle = g; c.fillRect(0, 0, W, H);
  }

  /* ---------------- 1. Turbo Dash ---------------- */
  function turboDash(api) {
    var lanes = [90, 180, 270], lane = 1, carX = 180, carY = H - 90;
    var obs = [], t = 0, dist = 0, speed = 230, spawn = 0.6, dash = 0;
    return {
      update: function (dt) {
        t += dt; speed += dt * 7; dist += speed * dt; dash = (dash + speed * dt) % 60;
        carX += (lanes[lane] - carX) * Math.min(1, dt * 14);
        spawn -= dt;
        if (spawn <= 0) {
          var free = Math.floor(Math.random() * 3);
          obs.push({ lane: free, y: -50, e: pick(['🚧', '🛢️', '🪨', '📦']) });
          if (t > 20 && Math.random() < 0.35) obs.push({ lane: (free + 1 + Math.floor(Math.random() * 2)) % 3, y: -50, e: '🚧' });
          spawn = Math.max(0.42, 1.05 - t * 0.012);
        }
        for (var i = obs.length - 1; i >= 0; i--) {
          var o = obs[i]; o.y += speed * dt;
          if (Math.abs(lanes[o.lane] - carX) < 44 && Math.abs(o.y - carY) < 50) { api.end(Math.floor(dist / 40)); return; }
          if (o.y > H + 60) obs.splice(i, 1);
        }
        api.score(Math.floor(dist / 40));
      },
      draw: function (c) {
        c.fillStyle = '#4ea585'; c.fillRect(0, 0, W, H);
        c.fillStyle = '#3a3f4b'; c.fillRect(35, 0, 290, H);
        c.fillStyle = '#fff';
        for (var y = -60 + dash; y < H; y += 60) { c.fillRect(133, y, 4, 30); c.fillRect(223, y, 4, 30); }
        c.fillStyle = '#f5b21e'; c.fillRect(35, 0, 5, H); c.fillRect(320, 0, 5, H);
        obs.forEach(function (o) { emoji(c, o.e, lanes[o.lane], o.y, 42); });
        // car
        c.save(); c.translate(carX, carY);
        c.fillStyle = '#f15a5d'; rrect(c, -24, -40, 48, 80, 12); c.fill();
        c.fillStyle = '#2b1a33'; rrect(c, -18, -24, 36, 18, 5); c.fill(); rrect(c, -18, 14, 36, 14, 5); c.fill();
        c.fillStyle = '#111'; c.fillRect(-29, -30, 6, 18); c.fillRect(23, -30, 6, 18); c.fillRect(-29, 14, 6, 18); c.fillRect(23, 14, 6, 18);
        c.fillStyle = '#fff6c7'; c.fillRect(-18, -40, 8, 4); c.fillRect(10, -40, 8, 4);
        c.restore();
      },
      tap: function (x) { lane = clamp(lane + (x < W / 2 ? -1 : 1), 0, 2); },
      key: function (k) { if (k === 'ArrowLeft') lane = clamp(lane - 1, 0, 2); if (k === 'ArrowRight') lane = clamp(lane + 1, 0, 2); }
    };
  }

  /* ---------------- 2. Brick Stack ---------------- */
  function brickStack(api) {
    var BH = 26, baseY = H - 70;
    var stack = [{ x: 80, w: 200 }];
    var mv = { x: 0, w: 200, dir: 1, speed: 150 };
    var cam = 0, camT = 0, falling = [], perfectFx = 0;
    function color(i) { return PALETTE[i % PALETTE.length]; }
    return {
      update: function (dt) {
        mv.x += mv.dir * mv.speed * dt;
        if (mv.x + mv.w > W - 10) { mv.x = W - 10 - mv.w; mv.dir = -1; }
        if (mv.x < 10) { mv.x = 10; mv.dir = 1; }
        camT = Math.max(0, (stack.length - 11) * BH);
        cam += (camT - cam) * Math.min(1, dt * 6);
        falling.forEach(function (f) { f.vy += 900 * dt; f.y += f.vy * dt; });
        falling = falling.filter(function (f) { return f.y < H + cam + 100; });
        if (perfectFx > 0) perfectFx -= dt;
      },
      draw: function (c) {
        sky(c, '#fff4d6', '#ffe0ef');
        c.save(); c.translate(0, cam);
        c.fillStyle = '#8c4c9e'; c.fillRect(60, baseY + BH, 240, 20);
        stack.forEach(function (b, i) {
          c.fillStyle = color(i); rrect(c, b.x, baseY - i * BH, b.w, BH - 2, 6); c.fill();
          c.fillStyle = 'rgba(255,255,255,.35)';
          for (var s = b.x + 12; s < b.x + b.w - 8; s += 28) { c.beginPath(); c.arc(s, baseY - i * BH + 5, 4, 0, 7); c.fill(); }
        });
        falling.forEach(function (f) { c.fillStyle = f.col; rrect(c, f.x, f.y, f.w, BH - 2, 6); c.fill(); });
        var my = baseY - stack.length * BH;
        c.fillStyle = color(stack.length); rrect(c, mv.x, my, mv.w, BH - 2, 6); c.fill();
        c.restore();
        if (perfectFx > 0) text(c, 'PERFECT!', W / 2, 80, 26, '#e76ca9');
      },
      tap: function () {
        var top = stack[stack.length - 1];
        var l = Math.max(top.x, mv.x), r = Math.min(top.x + top.w, mv.x + mv.w);
        var y = baseY - stack.length * BH;
        if (r - l <= 0) {
          falling.push({ x: mv.x, w: mv.w, y: y, vy: 0, col: color(stack.length) });
          api.end(stack.length - 1); return;
        }
        if (Math.abs(mv.x - top.x) < 5) { l = top.x; r = top.x + top.w; perfectFx = 0.7; }
        else {
          var cutX = mv.x < top.x ? mv.x : r, cutW = mv.w - (r - l);
          falling.push({ x: cutX, w: cutW, y: y, vy: 0, col: color(stack.length) });
        }
        stack.push({ x: l, w: r - l });
        mv = { x: Math.random() < 0.5 ? 10 : W - 10 - (r - l), w: r - l, dir: Math.random() < 0.5 ? 1 : -1, speed: Math.min(420, mv.speed + 14) };
        api.score(stack.length - 1);
      }
    };
  }

  /* ---------------- 3. Station Stop ---------------- */
  function stationStop(api) {
    var ROUNDS = 5, TARGET = 300, DECEL = 430;
    var round = 0, total = 0, x, v, braking, msg = '', msgT = 0, done;
    function next() { round++; x = -10; v = rnd(210, 330); braking = false; done = false; }
    next();
    return {
      update: function (dt) {
        if (msgT > 0) {
          msgT -= dt;
          if (msgT <= 0) { if (round >= ROUNDS) { api.end(total); return; } next(); }
          return;
        }
        if (braking) v = Math.max(0, v - DECEL * dt);
        x += v * dt;
        if (!done && (v === 0 || x > W + 140)) {
          done = true;
          var off = Math.abs(x - TARGET), pts = x > W + 140 ? 0 : Math.max(0, Math.round(100 - off * 2));
          total += pts;
          msg = pts >= 95 ? 'Perfect stop! +' + pts : pts >= 60 ? 'Nice! +' + pts : pts > 0 ? 'Close… +' + pts : (x > TARGET ? 'Overshot!' : 'Too early!');
          msgT = 1.3; api.score(total);
        }
      },
      draw: function (c) {
        sky(c, '#cdeffd', '#f2fbff');
        text(c, 'Station ' + Math.min(round, ROUNDS) + ' / ' + ROUNDS, W / 2, 50, 20, '#3d5dab');
        text(c, 'Tap to brake — stop the front at the flag', W / 2, 82, 12, '#555', 600);
        // platform
        c.fillStyle = '#d9c6a5'; c.fillRect(TARGET - 120, 300, 140, 26);
        c.fillStyle = '#8c4c9e'; c.fillRect(TARGET - 2, 230, 4, 70);
        emoji(c, '🚩', TARGET + 10, 226, 28);
        // rails
        c.fillStyle = '#6b4f3a'; for (var s = 0; s < W; s += 22) c.fillRect(s, 352, 12, 8);
        c.fillStyle = '#777'; c.fillRect(0, 346, W, 4); c.fillRect(0, 358, W, 4);
        // train (front at x)
        c.fillStyle = '#f15a5d'; rrect(c, x - 110, 300, 110, 46, 10); c.fill();
        c.fillStyle = '#3d5dab'; rrect(c, x - 230, 304, 112, 42, 8); c.fill();
        c.fillStyle = '#fff'; for (var w = 0; w < 3; w++) { c.fillRect(x - 100 + w * 30, 310, 20, 14); c.fillRect(x - 220 + w * 34, 312, 22, 14); }
        c.fillStyle = '#222'; [x - 95, x - 30, x - 210, x - 150].forEach(function (wx) { c.beginPath(); c.arc(wx, 348, 9, 0, 7); c.fill(); });
        if (braking && v > 0) text(c, 'BRAKING', W / 2, 420, 18, '#f15a5d');
        if (msgT > 0) text(c, msg, W / 2, 160, 24, '#2b1a33');
        text(c, 'Speed ' + Math.round(v / 3) + ' km/h', W / 2, 470, 14, '#555', 600);
      },
      tap: function () { if (msgT <= 0 && !done) braking = true; }
    };
  }

  /* ---------------- 4. Gear Shift ---------------- */
  function gearShift(api) {
    var gear = 1, n = 0, rate = 0.42, z0, zw = 0.2, flash = 0, flashOk = true;
    function zone() { zw = Math.max(0.07, 0.2 - gear * 0.012); z0 = rnd(0.48, 0.88 - zw); }
    zone();
    var CX = W / 2, CY = 300, R = 130;
    function ang(p) { return Math.PI + p * Math.PI; }
    return {
      update: function (dt) {
        n += rate * dt * (0.6 + n);
        if (flash > 0) flash -= dt;
        if (n >= 1) { api.end(gear - 1); }
      },
      draw: function (c) {
        sky(c, '#1f2230', '#2b2f40');
        c.lineWidth = 22; c.lineCap = 'butt';
        c.strokeStyle = '#3a3f52'; c.beginPath(); c.arc(CX, CY, R, Math.PI, 2 * Math.PI); c.stroke();
        c.strokeStyle = '#4ea585'; c.beginPath(); c.arc(CX, CY, R, ang(z0), ang(z0 + zw)); c.stroke();
        c.strokeStyle = '#f15a5d'; c.beginPath(); c.arc(CX, CY, R, ang(0.93), 2 * Math.PI); c.stroke();
        c.lineWidth = 5; c.strokeStyle = '#f5b21e';
        c.beginPath(); c.moveTo(CX, CY); c.lineTo(CX + Math.cos(ang(n)) * (R - 6), CY + Math.sin(ang(n)) * (R - 6)); c.stroke();
        c.fillStyle = '#f5b21e'; c.beginPath(); c.arc(CX, CY, 10, 0, 7); c.fill();
        text(c, 'GEAR', CX, CY + 50, 14, '#aab', 700);
        text(c, String(gear), CX, CY + 92, 54, '#fff');
        text(c, 'Tap when the needle is in the green', CX, 90, 13, '#cfd3e6', 600);
        if (flash > 0) text(c, flashOk ? 'SHIFT!' : '', CX, 130, 28, '#4ea585');
      },
      tap: function () {
        if (n >= z0 && n <= z0 + zw) { gear++; n = 0; rate *= 1.07; flash = 0.5; flashOk = true; zone(); api.score(gear - 1); }
        else { api.end(gear - 1); }
      }
    };
  }

  /* ---------------- 5. Claw Grab ---------------- */
  function clawGrab(api) {
    var TRIES = 10, tries = 0, got = 0, t = 0;
    var TOYS = ['🧸', '🚗', '🤖', '🦖', '🚂', '🪀', '🎲', '🦄', '🚁'];
    var belt = [];
    for (var i = 0; i < 5; i++) belt.push({ x: 30 + i * 80, e: pick(TOYS) });
    var clawX = W / 2, phase = 'move', cy = 90, held = null, msg = '', msgT = 0;
    var BELT_Y = H - 120;
    return {
      update: function (dt) {
        t += dt;
        belt.forEach(function (b) { b.x += 55 * dt; if (b.x > W + 40) { b.x -= 400; b.e = pick(TOYS); } });
        if (msgT > 0) msgT -= dt;
        if (phase === 'move') clawX = W / 2 + Math.sin(t * (1.5 + got * 0.12)) * 140;
        else if (phase === 'down') {
          cy += 380 * dt;
          if (cy >= BELT_Y - 40) {
            cy = BELT_Y - 40; phase = 'up';
            for (var i = 0; i < belt.length; i++) {
              if (Math.abs(belt[i].x - clawX) < 24) { held = belt[i].e; belt[i].x -= 400; belt[i].e = pick(TOYS); break; }
            }
            if (held) { got++; msg = 'Got it!'; } else { msg = 'Missed!'; }
            msgT = 0.8; api.score(got);
          }
        } else if (phase === 'up') {
          cy -= 380 * dt;
          if (cy <= 90) { cy = 90; phase = 'move'; held = null; if (tries >= TRIES) api.end(got); }
        }
      },
      draw: function (c) {
        sky(c, '#ffe0ef', '#fff4d6');
        c.fillStyle = '#8c4c9e'; c.fillRect(0, 40, W, 10);
        text(c, 'Tries left: ' + (TRIES - tries), W / 2, 22, 14, '#8c4c9e');
        c.strokeStyle = '#555'; c.lineWidth = 3; c.beginPath(); c.moveTo(clawX, 50); c.lineTo(clawX, cy); c.stroke();
        c.fillStyle = '#666'; rrect(c, clawX - 18, cy - 6, 36, 14, 4); c.fill();
        c.strokeStyle = '#666'; c.lineWidth = 5;
        c.beginPath(); c.moveTo(clawX - 14, cy + 8); c.lineTo(clawX - 22, cy + 30); c.lineTo(clawX - 10, cy + 40); c.stroke();
        c.beginPath(); c.moveTo(clawX + 14, cy + 8); c.lineTo(clawX + 22, cy + 30); c.lineTo(clawX + 10, cy + 40); c.stroke();
        if (held) emoji(c, held, clawX, cy + 36, 34);
        c.fillStyle = '#3a3f4b'; c.fillRect(0, BELT_Y + 22, W, 22);
        c.fillStyle = '#5c6270'; for (var s = (t * 55) % 30 - 30; s < W; s += 30) c.fillRect(s, BELT_Y + 30, 14, 6);
        belt.forEach(function (b) { emoji(c, b.e, b.x, BELT_Y, 38); });
        if (msgT > 0) text(c, msg, W / 2, 200, 26, msg === 'Got it!' ? '#4ea585' : '#f15a5d');
      },
      tap: function () { if (phase === 'move' && tries < TRIES) { phase = 'down'; tries++; } }
    };
  }

  /* ---------------- 6. Toy Match ---------------- */
  function toyMatch(api) {
    var E = ['🚗', '🧸', '🚂', '🤖', '✈️', '🎲', '🧩', '🚁'];
    var deck = E.concat(E).sort(function () { return Math.random() - 0.5; })
      .map(function (e) { return { e: e, up: false, done: false }; });
    var COLS = 4, CW = 76, CH = 92, GAP = 8, OX = (W - (COLS * CW + (COLS - 1) * GAP)) / 2, OY = 90;
    var open = [], wait = 0, moves = 0, pairs = 0, time = 0;
    return {
      update: function (dt) {
        time += dt;
        if (wait > 0) {
          wait -= dt;
          if (wait <= 0) { open.forEach(function (i) { deck[i].up = false; }); open = []; }
        }
      },
      draw: function (c) {
        sky(c, '#eaf7f1', '#fdf6ff');
        text(c, 'Moves ' + moves + '   ·   Pairs ' + pairs + '/8', W / 2, 50, 15, '#2b1a33');
        deck.forEach(function (d, i) {
          var x = OX + (i % COLS) * (CW + GAP), y = OY + Math.floor(i / COLS) * (CH + GAP);
          c.fillStyle = d.done ? '#d8f0e5' : d.up ? '#fff' : '#8c4c9e';
          rrect(c, x, y, CW, CH, 12); c.fill();
          if (d.up || d.done) emoji(c, d.e, x + CW / 2, y + CH / 2, 40);
          else text(c, '?', x + CW / 2, y + CH / 2, 30, '#f5b21e');
        });
      },
      tap: function (x, y) {
        if (wait > 0) return;
        var col = Math.floor((x - OX) / (CW + GAP)), row = Math.floor((y - OY) / (CH + GAP));
        if (col < 0 || col >= COLS || row < 0 || row >= 4) return;
        var i = row * COLS + col, d = deck[i];
        if (d.up || d.done) return;
        d.up = true; open.push(i);
        if (open.length === 2) {
          moves++;
          var a = deck[open[0]], b = deck[open[1]];
          if (a.e === b.e) {
            a.done = b.done = true; open = []; pairs++;
            if (pairs === 8) { api.end(Math.max(10, 300 - moves * 8 - Math.floor(time) * 2)); return; }
          } else { wait = 0.75; }
        }
        api.score(pairs);
      }
    };
  }

  /* ---------------- 7. Signal Switch ---------------- */
  function signalSwitch(api) {
    var JY = 290, LX = 80, RX = 280, SY = 470;
    var COLORS = [{ c: '#f15a5d', side: 0 }, { c: '#3d5dab', side: 1 }];
    var sw = 0, trains = [], spawn = 1, speed = 115, lives = 3, score = 0, t = 0, flash = 0;
    return {
      update: function (dt) {
        t += dt; speed = 115 + t * 2.2; spawn -= dt; if (flash > 0) flash -= dt;
        if (spawn <= 0) { trains.push({ y: -30, x: W / 2, k: pick(COLORS), dir: null, p: 0 }); spawn = Math.max(0.9, 2.1 - t * 0.02); }
        for (var i = trains.length - 1; i >= 0; i--) {
          var tr = trains[i];
          if (tr.dir === null) {
            tr.y += speed * dt;
            if (tr.y >= JY) { tr.y = JY; tr.dir = sw; }
          } else {
            tr.p = Math.min(1, tr.p + speed * dt / 240);
            var tx = tr.dir === 0 ? LX : RX;
            tr.x = W / 2 + (tx - W / 2) * tr.p; tr.y = JY + (SY - JY) * tr.p;
            if (tr.p >= 1) {
              if (tr.dir === tr.k.side) { score++; api.score(score); }
              else { lives--; flash = 0.4; if (lives <= 0) { api.end(score); return; } }
              trains.splice(i, 1);
            }
          }
        }
      },
      draw: function (c) {
        sky(c, '#eef3ff', '#fffaf0');
        if (flash > 0) { c.fillStyle = 'rgba(241,90,93,.18)'; c.fillRect(0, 0, W, H); }
        text(c, '❤'.repeat(lives) + '  ·  ' + score, W / 2, 30, 16, '#f15a5d');
        c.strokeStyle = '#8a7a6a'; c.lineWidth = 8; c.lineCap = 'round';
        c.beginPath(); c.moveTo(W / 2, 0); c.lineTo(W / 2, JY); c.stroke();
        [LX, RX].forEach(function (tx, side) {
          c.strokeStyle = side === sw ? '#4ea585' : '#c8bfb5';
          c.beginPath(); c.moveTo(W / 2, JY); c.lineTo(tx, SY); c.stroke();
        });
        c.fillStyle = '#f5b21e'; c.beginPath(); c.arc(W / 2, JY, 16, 0, 7); c.fill();
        text(c, sw === 0 ? '◀' : '▶', W / 2, JY + 1, 16, '#2b1a33');
        [[LX, '#f15a5d'], [RX, '#3d5dab']].forEach(function (s) {
          c.fillStyle = s[1]; rrect(c, s[0] - 50, SY + 6, 100, 34, 8); c.fill();
          text(c, 'STATION', s[0], SY + 23, 12, '#fff');
        });
        trains.forEach(function (tr) {
          c.fillStyle = tr.k.c; rrect(c, tr.x - 18, tr.y - 22, 36, 44, 8); c.fill();
          c.fillStyle = '#fff'; c.fillRect(tr.x - 11, tr.y - 14, 22, 10);
        });
        text(c, 'Tap to flip the switch — send each train to its colour', W / 2, H - 14, 11, '#666', 600);
      },
      tap: function () { sw = 1 - sw; },
      key: function (k) { if (k === 'ArrowLeft') sw = 0; if (k === 'ArrowRight') sw = 1; }
    };
  }

  /* ---------------- 8. Sky Hopper ---------------- */
  function skyHopper(api) {
    var y = H / 2, vy = 0, x = 90, towers = [], spawn = 0.4, score = 0, t = 0;
    var GAP = 160, TW = 56, SPEED = 150;
    var clouds = [0, 1, 2, 3].map(function (i) { return { x: i * 110, y: rnd(40, 300) }; });
    return {
      update: function (dt) {
        t += dt; vy += 1250 * dt; y += vy * dt; spawn -= dt;
        clouds.forEach(function (cl) { cl.x -= 30 * dt; if (cl.x < -60) { cl.x = W + 40; cl.y = rnd(40, 300); } });
        if (spawn <= 0) { towers.push({ x: W + 10, gy: rnd(110, H - 110 - GAP), passed: false }); spawn = 1.55; }
        for (var i = towers.length - 1; i >= 0; i--) {
          var tw = towers[i]; tw.x -= (SPEED + score * 3) * dt;
          if (!tw.passed && tw.x + TW < x) { tw.passed = true; score++; api.score(score); }
          if (x + 16 > tw.x && x - 16 < tw.x + TW && (y - 14 < tw.gy || y + 14 > tw.gy + GAP)) { api.end(score); return; }
          if (tw.x < -80) towers.splice(i, 1);
        }
        if (y > H - 30 || y < 0) api.end(score);
      },
      draw: function (c) {
        sky(c, '#9fdcf5', '#e8f8ff');
        c.fillStyle = 'rgba(255,255,255,.9)';
        clouds.forEach(function (cl) { c.beginPath(); c.arc(cl.x, cl.y, 18, 0, 7); c.arc(cl.x + 20, cl.y - 8, 22, 0, 7); c.arc(cl.x + 42, cl.y, 18, 0, 7); c.fill(); });
        towers.forEach(function (tw, i) {
          c.fillStyle = PALETTE[i % PALETTE.length];
          rrect(c, tw.x, -10, TW, tw.gy + 10, 8); c.fill();
          rrect(c, tw.x, tw.gy + GAP, TW, H, 8); c.fill();
        });
        c.fillStyle = '#4ea585'; c.fillRect(0, H - 24, W, 24);
        c.save(); c.translate(x, y); c.rotate(clamp(vy / 900, -0.5, 0.8));
        emoji(c, '✈️', 0, 0, 34); c.restore();
        text(c, String(score), W / 2, 60, 40, '#fff');
      },
      tap: function () { vy = -390; }
    };
  }

  var GAMES = [
    { id: 'turbo-dash', name: 'Turbo Dash', emoji: '🏎️', color: '#f15a5d', how: 'Tap left or right to switch lanes and dodge the roadblocks.', make: turboDash },
    { id: 'brick-stack', name: 'Brick Stack', emoji: '🧱', color: '#f5b21e', how: 'Tap to drop each brick. Line them up perfectly to keep them wide.', make: brickStack },
    { id: 'station-stop', name: 'Station Stop', emoji: '🚉', color: '#3d5dab', how: 'Tap to brake. Stop the train’s front right at the flag — 5 stations.', make: stationStop },
    { id: 'gear-shift', name: 'Gear Shift', emoji: '⚙️', color: '#2b2f40', how: 'Tap when the needle is in the green zone to shift up. Miss and you stall!', make: gearShift },
    { id: 'claw-grab', name: 'Claw Grab', emoji: '🧸', color: '#e76ca9', how: 'Tap to drop the claw and grab a toy. You get 10 tries.', make: clawGrab },
    { id: 'toy-match', name: 'Toy Match', emoji: '🃏', color: '#8c4c9e', how: 'Flip two cards at a time and find all 8 toy pairs in as few moves as you can.', make: toyMatch },
    { id: 'signal-switch', name: 'Signal Switch', emoji: '🚦', color: '#4ea585', how: 'Tap to flip the junction and send each train to the station of its colour.', make: signalSwitch },
    { id: 'sky-hopper', name: 'Sky Hopper', emoji: '✈️', color: '#0ac0dd', how: 'Tap to fly up and glide through the gaps between the towers.', make: skyHopper }
  ];

  /* ---------------- Engine ---------------- */
  function PlayZone(root) {
    var grid = root.querySelector('[data-pz-grid]');
    var stage = root.querySelector('[data-pz-stage]');
    var canvas = root.querySelector('canvas');
    var ctx = canvas.getContext('2d');
    var elTitle = root.querySelector('[data-pz-title]');
    var elScore = root.querySelector('[data-pz-score]');
    var elBest = root.querySelector('[data-pz-best]');
    var overlay = root.querySelector('[data-pz-overlay]');
    var ovTitle = root.querySelector('[data-pz-ov-title]');
    var ovText = root.querySelector('[data-pz-ov-text]');
    var ovBtn = root.querySelector('[data-pz-ov-btn]');
    var cur = null, game = null, state = 'idle', raf = 0, last = 0;

    function renderGrid() {
      grid.innerHTML = '';
      GAMES.forEach(function (g) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'jt-pz__card'; b.style.setProperty('--pz-c', g.color);
        var best = store.get(g.id);
        b.innerHTML = '<span class="jt-pz__icon" aria-hidden="true">' + g.emoji + '</span>' +
          '<span class="jt-pz__name">' + g.name + '</span>' +
          '<span class="jt-pz__best">' + (best ? 'Best: ' + best : 'Play now') + '</span>';
        b.addEventListener('click', function () { open(g); });
        grid.appendChild(b);
      });
    }

    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    var api = {
      score: function (n) { elScore.textContent = n; },
      end: function (n) {
        if (state !== 'play') return;
        state = 'over';
        var best = store.get(cur.id), isBest = n > best;
        if (isBest) store.set(cur.id, n);
        elScore.textContent = n; elBest.textContent = Math.max(n, best);
        ovTitle.textContent = isBest && n > 0 ? 'New best! ' + n : 'Score: ' + n;
        ovText.textContent = 'Best: ' + Math.max(n, best) + '. Want another go?';
        ovBtn.textContent = 'Play again';
        overlay.hidden = false;
      }
    };

    function fresh() { game = cur.make(api); elScore.textContent = '0'; }

    function open(g) {
      cur = g; elTitle.textContent = g.emoji + ' ' + g.name;
      elBest.textContent = store.get(g.id);
      grid.hidden = true; stage.hidden = false;
      root.querySelector('[data-pz-intro]').hidden = true;
      size(); fresh(); state = 'ready';
      ovTitle.textContent = g.name; ovText.textContent = g.how; ovBtn.textContent = 'Start';
      overlay.hidden = false;
      game.draw(ctx);
      stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      loop();
    }

    function close() {
      state = 'idle'; cancelAnimationFrame(raf);
      stage.hidden = true; grid.hidden = false;
      root.querySelector('[data-pz-intro]').hidden = false;
      renderGrid();
    }

    function start() {
      if (state === 'over') fresh();
      overlay.hidden = true; state = 'play'; last = performance.now();
    }

    function loop() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function step(now) {
        if (state === 'idle') return;
        var dt = Math.min(0.05, (now - last) / 1000); last = now;
        if (state === 'play') game.update(dt);
        game.draw(ctx);
        raf = requestAnimationFrame(step);
      });
    }

    function point(e) {
      var r = canvas.getBoundingClientRect();
      return { x: (e.clientX - r.left) * W / r.width, y: (e.clientY - r.top) * H / r.height };
    }
    canvas.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      if (state !== 'play') { start(); return; }
      var p = point(e); if (game.tap) game.tap(p.x, p.y);
    });
    document.addEventListener('keydown', function (e) {
      if (stage.hidden || state === 'idle') return;
      var k = e.key;
      if (k === ' ' || k === 'ArrowUp' || k === 'Enter') {
        e.preventDefault();
        if (state !== 'play') { start(); return; }
        if (game.tap) game.tap(W / 2, H / 2);
      } else if ((k === 'ArrowLeft' || k === 'ArrowRight') && state === 'play') {
        e.preventDefault();
        if (game.key) game.key(k); else if (game.tap) game.tap(k === 'ArrowLeft' ? 10 : W - 10, H / 2);
      } else if (k === 'Escape') { close(); }
    });
    ovBtn.addEventListener('click', start);
    root.querySelector('[data-pz-back]').addEventListener('click', close);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && state === 'play') { state = 'paused'; ovTitle.textContent = 'Paused'; ovText.textContent = 'Tap to keep playing.'; ovBtn.textContent = 'Resume'; overlay.hidden = false; }
    });
    renderGrid();
  }

  window.JTPlayZoneGames = GAMES; // exposed for testing
  function init() { document.querySelectorAll('[data-jt-play-zone]:not([data-ready])').forEach(function (r) { r.setAttribute('data-ready', '1'); PlayZone(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
